import AboutMuseum from "components/common/dl_group/introduction/AboutMuseum";
import SavaSumanovic from "components/common/dl_group/introduction/SavaSumanovic";
import Avangarda from "components/common/dl_group/introduction/Avangarda/Avangarda";
import ConceptualArt from "components/common/dl_group/introduction/ConceptualArt/ConceptualArt";
import OctoberSalon from "components/common/dl_group/introduction/OctoberSalon";
import NadezdaPetrovic from "components/common/dl_group/introduction/NadezdaPetrovic/NadezdaPetrovic";
import PetarLubarda from "components/common/dl_group/introduction/PetarLubarda/PetarLubarda";

import { DL_GROUP_SLUG } from "constant/dl_group/dl_group.constant";
import { useParams } from "react-router-dom";

export default function GroupIntroduction() {
  const { slug } = useParams();

  if (!slug) {
    return <></>;
  }

  return (
    <>
      {slug === DL_GROUP_SLUG.MuzejSavremeneUmetnosti && <AboutMuseum />}
      {slug === DL_GROUP_SLUG.PetarLubarda && <PetarLubarda />}
      {slug === DL_GROUP_SLUG.SavaSumanovic && <SavaSumanovic />}
      {slug === DL_GROUP_SLUG.NadezdaPetrovic && <NadezdaPetrovic />}
      {slug === DL_GROUP_SLUG.Avangarda && <Avangarda />}
      {slug === DL_GROUP_SLUG.OktobarskiSalon && <OctoberSalon />}
      {slug === DL_GROUP_SLUG.KonceptualnaUmetnost && <ConceptualArt />}
    </>
  );
}
